import { secureApiCall } from "./authHeader";

export const obtenerParametrosFlow = async (flow) => {
  const flowParam = encodeURIComponent(flow);
  return secureApiCall(`api/v1/parametros/flow/${flowParam}`, "get");
};
